import axios from "axios";
import { Controller } from "@hotwired/stimulus";
import WaitBox from "../src/waitbox"

export default class extends Controller {
  static targets = ["form", "paymentNoField"]
  static values = { endpoint: String, pkey: String, callbackUrl: String, accountNo: String,
    createReservationUrl: String, finalizeReservationUrl: String, amount: String}

  connect() {
    initEzidebitInputs()
    this.initPayNow()
  }

  initPayNow() {
    const pkey = this.pkeyValue
    const endpoint = this.endpointValue

    eziDebit.init(pkey, {
      submitAction: "ChargeCard",
      submitButton: "payNowButton",
      submitCallback: (data) => this.submitSuccessCallback(data),
      submitError: (data) => this.handleSubmitError(data),
      onFormError: () => this.handleFormError(),
      beforeSubmitCallback: () => this.prepareSubmitToEzidebit(),
      beforeEzidebitApiCall: () => this.beforeEzidebitApiCall(),
      nameOnCard: "nameOnCard",
      cardNumber: "cardNumber",
      cardExpiryMonth: "expiryMonth",
      cardExpiryYear: "expiryYear",
      cardCCV: "ccv",
      paymentAmount: "amount",
      paymentReference: "paymentReference"
    }, endpoint);
  }

  async prepareSubmitToEzidebit() {
    const createReservationUrl = this.createReservationUrlValue;
    const amount = this.amountValue;

    try {
      const result = await this.createReservation(createReservationUrl, { amount: amount });

      if (result.ok) {
        const paymentNo = result.data.payment_no;
        const paymentReference = `${paymentNo}-${this.accountNoValue}`;
        $("#paymentReference").val(paymentReference);
        this.paymentNoFieldTarget.value = paymentNo;
        return true;
      } else {
        this.handleSubmitError(result.error, false);
        return false;
      }
    } catch (error) {
      this.handleSubmitError(error, false);
      return false;
    }
  }

  submitSuccessCallback(data) {
    if (data["ErrorMessage"] != null) {
      this.handleSubmitError(data["ErrorMessage"])
    } else {
      let paymentData = data

      Object.assign(paymentData, {
        amount: $("#amount").val(),
        payment_reference: $("#paymentReference").val(),
        masked_card_number: maskString($("#cardNumber").val())
      });
      this.createPayment(paymentData)
    }
  }

  async handleSubmitError(error, shouldFinalize=true) {
    if(shouldFinalize) {
      const result = await this.finalizeReservation(error);
    }

    WaitBox.hide();
    bootbox.alert({
      title: formatBootboxTitle(false, "  Failed"),
      className: "failure-modal",
      message: error,
      callback: function() {
        enableSubmitButton("#payNowButton", "Pay Now")
      }
    })
  }

  handleFormError() {
    const error = "Form data validation failed";
    this.finalizeReservation(error);
    WaitBox.hide();
    enableSubmitButton("#payNowButton", "Pay Now")
  }

  createPayment(paymentData) {
    const url = this.callbackUrlValue;
    axios.post(url,
      { authenticity_token: this.csrfToken(), transaction: paymentData },
      { headers: { 'Accept': 'text/vnd.turbo-stream.html', 'X-CSRF-Token': this.csrfToken() } }
    )
    .then(response => {
      WaitBox.hide();
      Turbo.renderStreamMessage(response.data);
    })
    .catch(error => {
      WaitBox.hide();
      showErrorMessage(error);
    });
  }

  beforeEzidebitApiCall() {
    WaitBox.show({ message: "Processing your payment. Please wait and do not refresh or close this page."})
  }

  async createReservation(url, data) {
    try {
      const resp = await axios.post(
        url,
        { authenticity_token: this.csrfToken(), payment_reservation: data },
        { headers: { 'X-CSRF-Token':  this.csrfToken() } }
      );

      return { ok: true, data: resp.data };
    } catch (err) {
      const msg = err?.response?.data?.error || err?.response?.data?.message || err?.message || 'Request failed';
      return { ok: false, error: msg, status: err?.response?.status };
    }
  }

  async finalizeReservation(error){
    const url = this.finalizeReservationUrlValue;
    const paymentNo = this.paymentNoFieldTarget.value;

    try {
        const resp = await axios.patch(
          url,
          {
            authenticity_token: this.csrfToken(),
            payment_reservation: {
              payment_no: paymentNo,
              status: 'failed',
              failed_reason: error
            }
          },
          { headers: { 'X-CSRF-Token': this.csrfToken() } }
        );
        return resp.data; // <— return data so caller can await/use it
      } catch (err) {
        return {error: error}
      }
  }


  csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content;
  }
}